export default __webpack_public_path__ + "static/media/experiment.884a709b.svg";